/**
 * Typed provider location operations API facade over the generated contract client.
 */

import { providerLocationOperationsApi } from '../api/generated/providerLocationOperations.api.js';
import {
  type ProviderOperationsDashboardResponse,
  type SiteAnchorHealthListQuery,
  type SiteAnchorHealthListResponse,
  type SiteTagFleetListQuery,
  type SiteTagFleetListResponse,
  type SiteTagFleetTagsListQuery,
  type SiteTagFleetTagsListResponse,
  type UwbDeploymentStatusResponse,
} from '@cnapse/shared/schemas.js';

class ProviderLocationOperationsService {
  async getProviderOperationsDashboard(): Promise<ProviderOperationsDashboardResponse> {
    return providerLocationOperationsApi.getDashboard({}) as Promise<ProviderOperationsDashboardResponse>;
  }

  async getUwbDeploymentStatus(): Promise<UwbDeploymentStatusResponse> {
    return providerLocationOperationsApi.getUwbStatus({}) as Promise<UwbDeploymentStatusResponse>;
  }

  async getSiteAnchorHealthList(
    query: SiteAnchorHealthListQuery,
  ): Promise<SiteAnchorHealthListResponse> {
    return providerLocationOperationsApi.listSiteAnchorHealth(query) as Promise<SiteAnchorHealthListResponse>;
  }

  async getSiteTagFleetList(query: SiteTagFleetListQuery): Promise<SiteTagFleetListResponse> {
    return providerLocationOperationsApi.listSiteTagFleet(query) as Promise<SiteTagFleetListResponse>;
  }

  async getSiteTagFleetTags(
    tenantId: string,
    siteId: string,
    query?: SiteTagFleetTagsListQuery,
  ): Promise<SiteTagFleetTagsListResponse> {
    return providerLocationOperationsApi.listSiteTagFleetTags(
      { tenantId, siteId },
      query ?? {},
    ) as Promise<SiteTagFleetTagsListResponse>;
  }
}

export const providerLocationOperationsService = new ProviderLocationOperationsService();
